import React, { useEffect, useState } from "react";
import api, { apiError } from "@/lib/api";
import { money } from "@/lib/format";
import { toast } from "sonner";

const STATUSES = ["paid", "shipped", "delivered", "cancelled"];

export default function AdminTelecomOrders() {
  const [orders, setOrders] = useState([]);
  const [loading, setLoading] = useState(true);

  const load = async () => {
    setLoading(true);
    try { const { data } = await api.get("/telecom/shop/orders"); setOrders(data.orders || []); }
    catch (e) { toast.error(apiError(e)); } finally { setLoading(false); }
  };
  useEffect(() => { load(); }, []);

  const setStatus = async (sid, status) => {
    try { await api.patch(`/telecom/shop/orders/${sid}`, { status }); setOrders((o) => o.map((x) => x.session_id === sid ? { ...x, status } : x)); toast.success("Updated"); }
    catch (e) { toast.error(apiError(e)); }
  };

  if (loading) return <div className="p-6 text-sm text-muted-foreground">Loading orders…</div>;

  return (
    <div className="mx-auto max-w-4xl space-y-4" data-testid="admin-telecom-orders">
      <h1 className="font-display text-2xl font-semibold">Hardware Orders</h1>
      {orders.length === 0 && <p className="text-sm text-muted-foreground">No orders yet.</p>}
      <div className="space-y-3">
        {orders.map((o) => (
          <div key={o.session_id} data-testid={`order-${o.session_id}`} className="rounded-2xl border border-border bg-card p-4">
            <div className="flex items-start justify-between gap-3">
              <div className="min-w-0">
                <p className="font-semibold">{o.product_name} <span className="text-muted-foreground">× {o.qty}</span></p>
                <p className="text-sm text-muted-foreground">{money(o.amount_cents, "USD")} · {o.email || "—"} · {o.phone || ""}</p>
                <p className="mt-1 text-sm">{o.ship_name}</p>
                <p className="text-xs text-muted-foreground">
                  {[o.address?.line1, o.address?.line2, o.address?.city, o.address?.state, o.address?.postal_code, o.address?.country].filter(Boolean).join(", ") || "No address"}
                </p>
              </div>
              <select value={o.status} onChange={(e) => setStatus(o.session_id, e.target.value)} data-testid={`status-${o.session_id}`}
                className="rounded-lg border border-input bg-background px-2 py-1.5 text-sm">
                {STATUSES.map((s) => <option key={s} value={s}>{s}</option>)}
              </select>
            </div>
          </div>
        ))}
      </div>
    </div>
  );
}
